/**
 * URL-ul de incorporare pentru filmul unei lectii, pe pagina publica a colaboratorului. Pur, fara DOM.
 *
 * `SlideDTO.video` e de regula ID-ul YouTube (11 caractere), dar editorul a acceptat in timp si
 * adrese intregi. Orice nu se recunoaste da `null`, iar filmul nu se afiseaza - nu punem intr-un
 * iframe o adresa oarecare venita din continut.
 */
const ID_YOUTUBE = /^[A-Za-z0-9_-]{11}$/;
const DIN_ADRESA = /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;

export function idYoutube(video: string | null | undefined): string | null {
    const v = (video ?? '').trim();
    if (!v) return null;
    if (ID_YOUTUBE.test(v)) return v;
    return DIN_ADRESA.exec(v)?.[1] ?? null;
}

/** `youtube-nocookie`, fara autoplay si fara filme recomandate; `start`/`end` doar cand sunt pozitive. */
export function urlIncorporare(
    video: string | null | undefined,
    start?: number | null,
    end?: number | null
): string | null {
    const id = idYoutube(video);
    if (!id) return null;
    const params = new URLSearchParams({ rel: '0', modestbranding: '1' });
    if (typeof start === 'number' && start > 0) params.set('start', String(Math.floor(start)));
    if (typeof end === 'number' && end > 0) params.set('end', String(Math.floor(end)));
    return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;
}
